// extracted by mini-css-extract-plugin
export var root = "reveal-module--root--ppuyZ";
export var reveal = "reveal-module--reveal--sCe8Q";